<div class="d-flex p-4 justify-content-between" [formGroup]="serviceFormGroup">
  <div class="packages row">
    <ng-container *ngIf="unitofMeasureSelected">
      <div class="col-3" formArrayName="packaging">
        <h4>Pricing Packages</h4>
        <div class="packages-list">
          <div class="" style="max-width: 15rem">
            <ul class="list-group list-group-flush border-0">
              <li
                class="list-group-item my-2 border-0 action"
                [class.active]="selectedPackage === i"
                (click)="selectPackage(i)"
                *ngFor="let item of packagingForm.controls; let i = index"
              >
                <div>
                  <div class="title">
                    {{ item.controls.name.value }}
                  </div>
                  <div class="amount">
                    {{ item.controls.price.value | currency: "UGX" }}
                  </div>
                </div>
                <span class="icon">
                  <div>
                    <ezy-icons src="/assets/icons/angle-right.svg"></ezy-icons>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <button class="btn btn-outline-primary mt-3" (click)="addPackage()">
          <ezy-icons
            src="/assets/icons/plus-primary.svg"
            class="text-outline-primary"
          ></ezy-icons>
          Add New Package
        </button>
      </div>
      <div
        class="col-5"
        *ngIf="hasUnits"
        [formGroup]="packagingForm.controls[selectedPackage]"
      >
        <div class="form-group">
          <label required>Package Name</label>
          <input
            type="text"
            class="form-control"
            formControlName="name"
            placeholder="Enter package name"
          />
        </div>
        <div class="form-group">
          <label required
            >Price per
            {{ (unitofMeasure$ | async).singular | lowercase }}</label
          >
          <input
            type="number"
            class="form-control"
            formControlName="price"
            placeholder="Enter price per {{
              (unitofMeasure$ | async).singular | lowercase
            }}"
          />
        </div>
        <div class="form-group">
          <label required>Minimum order quantity</label>
          <input
            type="number"
            class="form-control"
            formControlName="minimum_order"
          />
        </div>
        <div class="form-group">
          <label required>Description</label>
          <textarea
            class="form-control"
            formControlName="description"
            placeholder="Enter description"
          >
          </textarea>
        </div>
        <div class="form-group custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            [ngModel]="isSelected"
            [ngModelOptions]="{ standalone: true }"
            (click)="handleChangeDefaultPackage($event)"
            id="customSwitch-{{ selectedPackage }}"
          />
          <label
            class="custom-control-label"
            for="customSwitch-{{ selectedPackage }}"
            >Is Default Package</label
          >
        </div>
        <div class="form-group">
          <label required>Price tiers</label>
          <small class="form-text text-muted"
            >Set price discounts based on order size</small
          >
        </div>
        <div>
          <ul
            class="list-group list-group-flush border-0"
            formGroupName="pricing"
          >
            <li class="list-group-item border-0 p-0">
              <div class="row">
                <div class="col measurements">
                  <label required>{{
                    (unitofMeasure$ | async).plural | titlecase
                  }}</label>
                </div>
                <div class="price col">
                  <label required
                    >Price per
                    {{ (unitofMeasure$ | async).singular | lowercase }}</label
                  >
                </div>
              </div>
            </li>
            <li
              class="list-group-item border-0 px-0 py-2"
              [formGroupName]="i"
              *ngFor="let item of pricing.controls; let i = index"
            >
              <div class="row">
                <div class="col measurements">
                  <input
                    type="number"
                    class="form-control"
                    id="{{ i }}_min"
                    formControlName="min"
                    placeholder="Enter minimum value to apply discount"
                  />
                </div>
                <div class="price col">
                  <input
                    type="number"
                    id="{{ i }}_price"
                    class="form-control"
                    formControlName="price"
                    placeholder="Enter price per {{
                      (unitofMeasure$ | async).singular | lowercase
                    }}"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="form-group">
          <small>
            <a
              class="text-primary text-decoration-underline"
              (click)="handleAddTier()"
              >Add Tier</a
            >
          </small>
        </div>
        <div class="form-group">
          <button
            class="btn btn-sm btn-danger"
            *ngIf="hasMoreThanOnePackage"
            (click)="deletePackage()"
          >
            Delete Package
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!unitofMeasureSelected">
      <div class="col-12">
        <h4>Please select a unit of charge on the overview tab</h4>
      </div>
    </ng-container>
  </div>
  <div>
    <app-service-action-bar></app-service-action-bar>
  </div>
</div>
<router-outlet></router-outlet>
